var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "ghost" } },
    [
      _c(
        "d2-module-index-banner",
        _vm._b(
          { attrs: { slot: "header" }, slot: "header" },
          "d2-module-index-banner",
          _vm.banner,
          false
        )
      ),
      _c("d2-module-index-menu", { attrs: { menu: _vm.menu } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }